import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TwoFAOutlineIcon } from 'foundations-assets/icons/components/TwoFAOutlineIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { HR } from 'foundations-components/transitional/components/HR';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Media, MediaBody, MediaLeft, MediaRight } from 'foundations-components/transitional/components/Media';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnterpriseManagedAuthTile() {
  const [isOpen, setIsOpen] = useState(false);
  const [issuerUrl, setIssuerUrl] = useState('');
  return /*#__PURE__*/_jsxs(Tile, {
    compact: true,
    children: [/*#__PURE__*/_jsx(TileSection, {
      children: /*#__PURE__*/_jsxs(Media, {
        align: "start",
        children: [/*#__PURE__*/_jsx(MediaLeft, {
          children: /*#__PURE__*/_jsx(IconHolder, {
            icon: TwoFAOutlineIcon,
            size: "400",
            padding: "200",
            borderRadius: "200",
            backgroundColor: "fill-accent-blue-subtle"
          })
        }), /*#__PURE__*/_jsxs(MediaBody, {
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "200",
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h5",
              marginBlockEnd: "0",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.advanced.ema.title"
              })
            }), /*#__PURE__*/_jsx(Badge, {
              use: "beta",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.advanced.ema.beta"
              })
            })]
          }), /*#__PURE__*/_jsx(Paragraph, {
            color: "text-core-subtle",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app-governance-lib.advanced.ema.description"
            })
          })]
        }), /*#__PURE__*/_jsx(MediaRight, {
          children: /*#__PURE__*/_jsx(Toggle, {
            size: "extra-small",
            checked: isOpen,
            "aria-label": I18n.text('app-governance-lib.advanced.ema.title'),
            onChange: () => setIsOpen(prev => !prev)
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(AccordionTransition, {
      open: isOpen,
      children: [/*#__PURE__*/_jsx(HR, {
        distance: "flush"
      }), /*#__PURE__*/_jsx(TileSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          gap: "400",
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(StatusTag, {
            use: "inReview",
            children: /*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              color: "text-core-default",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.advanced.ema.setup.status"
              })
            })
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-50",
            children: /*#__PURE__*/_jsxs(List, {
              ordered: true,
              styled: true,
              listStylePosition: "inside",
              paddingInlineStart: "0",
              children: [/*#__PURE__*/_jsxs(ListItem, {
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.advanced.ema.setup.accountId.step"
                }), /*#__PURE__*/_jsx(FormControl, {
                  label: I18n.text('app-governance-lib.advanced.ema.setup.accountId.label'),
                  help: I18n.text('app-governance-lib.advanced.ema.setup.accountId.help'),
                  marginBlockEnd: "400",
                  children: /*#__PURE__*/_jsx(CopyInput, {
                    value: "1234567890"
                  })
                })]
              }), /*#__PURE__*/_jsxs(ListItem, {
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.advanced.ema.setup.issuerUrl.step"
                }), /*#__PURE__*/_jsx(FormControl, {
                  label: I18n.text('app-governance-lib.advanced.ema.setup.issuerUrl.label'),
                  required: true,
                  help: I18n.text('app-governance-lib.advanced.ema.setup.issuerUrl.help'),
                  children: /*#__PURE__*/_jsx(TextInput, {
                    value: issuerUrl,
                    onChange: e => setIssuerUrl(e.target.value),
                    placeholder: I18n.text('app-governance-lib.advanced.ema.setup.issuerUrl.placeholder')
                  })
                })]
              })]
            })
          }), /*#__PURE__*/_jsx(Alert, {
            type: "warning",
            titleText: I18n.text('app-governance-lib.advanced.ema.setup.alert.title'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app-governance-lib.advanced.ema.setup.alert.description"
            })
          }), /*#__PURE__*/_jsxs(ButtonWrapper, {
            children: [/*#__PURE__*/_jsx(Button, {
              use: "primary",
              disabled: issuerUrl.trim() === '',
              onClick: () => console.log('TODO: Handle turn on'),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.advanced.ema.setup.turnOn"
              })
            }), /*#__PURE__*/_jsx(Button, {
              use: "secondary",
              onClick: () => setIsOpen(false),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app-governance-lib.advanced.ema.setup.cancel"
              })
            })]
          })]
        })
      })]
    })]
  });
}